import { getLocale } from '../../utils/pathHelper';

type TranslationKeys = 'numberOfPeople' | 'vouchersSelected' | 'qrCodesInTotal' | 'voucherCount' | 'redeemAtSkiResort';

type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

export type ITranslation = {
  [key in TranslationKeys]: (object?: { [arg: string]: string|number }) => string;
}

const locales: {
  [locale in TranslationLocales]: ITranslation
} = {
  en: {
    numberOfPeople: ({ number }) => number === 1 ? `${number} person` : `${number} people`,
    vouchersSelected: ({ number }) => number === 1 ? `${number} voucher selected` : `${number} vouchers selected`,
    qrCodesInTotal: ({ number }) => number === 1 ? `${number} QR code in total` : `${number} QR codes in total`,
    voucherCount: ({ number }) => number === 1 ? `${number} voucher` : `${number} vouchers`,
    redeemAtSkiResort: ({ resortName }) => `Redeem at ${resortName} ski resort`
  },
  ja: {
    numberOfPeople: ({ number }) =>`${number} 人`,
    vouchersSelected: ({ number }) => `${number}枚選択中`,
    qrCodesInTotal: ({ number }) => `QRコード合計 ${number}枚`,
    voucherCount:  ({ number }) => `${number}枚`,
    redeemAtSkiResort: ({ resortName }) => `${resortName}スキー場で引き換え`,
  },
  'zh-CN': {
    numberOfPeople: ({ number }) =>`${number} 人`,
    vouchersSelected: ({ number }) => `已选择${number}张`,
    qrCodesInTotal: ({ number }) => `二维码合计 ${number}张`,
    voucherCount: ({ number }) => `${number}张`,
    redeemAtSkiResort: ({ resortName }) => `在${resortName}滑雪场兑换`,
  },
  'zh-HK': {
    numberOfPeople: ({ number }) =>`${number} 人`,
    vouchersSelected: ({ number }) => `已選擇${number}張`,
    qrCodesInTotal: ({ number }) => `QR code合共 ${number}個`,
    voucherCount: ({ number }) => `${number}個`,
    redeemAtSkiResort: ({ resortName }) => `在${resortName}滑雪場兌換`,
  },
  'zh-TW': {
    numberOfPeople: ({ number }) =>`${number} 人`,
    vouchersSelected: ({ number }) => `已選擇${number}張`,
    qrCodesInTotal: ({ number }) => `QR code共計 ${number}張`,
    voucherCount: ({ number }) => `${number}張`,
    redeemAtSkiResort: ({ resortName }) => `在${resortName}滑雪場兌換`,
  },
};

const t: ITranslation = locales[getLocale() || 'en'];

export default t;
